<template>
  <div>
    <b-card class="m-3" no-body>
      <template #header>
        <h6 class="mb-0 text-center">
          <span class="titulo-sagres font-weight-bold">
            Entrega de Legislação
          </span>
          <btn-voltar v-if="!openInModal" url="/entrega/legislacoes" />
          <b-button class="float-right m-1" size="sm" :disabled="isBtnEnviarDesabilitado()" @click="enviarLegislacao()">
            <font-awesome-icon icon="save" />
            Enviar
          </b-button>
          <b-button class="float-right m-1" size="sm" :disabled="!Boolean(legEmAndamento)"
            @click="perguntarRemoverEntrega()">
            <font-awesome-icon icon="times" />
            Descartar
          </b-button>
        </h6>
      </template>
      <b-card-body>
        <b-card class="m-3" no-body>
          <template #header>
            <h6 class="mb-0 text-center">
              <span class="titulo-sagres font-weight-bold">
                Dados da Legislação
              </span>
            </h6>
          </template>
          <b-card-body>
            <b-row class="text-justify mb-3">
              <b-col cols="4">
                <b-form-group id="input-group-exercicio" label-size="md" label="Exercício">
                  <b-form-select id="select-filtros-exercicio" v-model="entrega.exercicio" :options="comboExercicio"
                    @change="habilitarTipoEntrega()" :disabled="existeEmAndamento()">
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="8">
                <b-form-group id="input-group-tipo-de-entrega" label-size="md" label="Tipo de Entrega">
                  <b-form-select id="select-filtros-tipoDeEntrega" v-model="entrega.idTipoEntrega"
                    @change="salvarLegislacao()" :disabled="tipoEntregaDesabilitado" :options="comboTiposDeEntrega">
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>

        <b-card class="m-3" no-body v-if="Boolean(legEmAndamento)">
          <template #header>
            <h6 class="mb-0 text-center">
              <span class="titulo-sagres font-weight-bold">
                Documentos
              </span>
              <b-button size="sm" class="float-right m-1" @click="abrirModalDocumento()">
                <font-awesome-icon icon="plus" class="mr-3" />
                Adicionar Documento
              </b-button>
            </h6>
          </template>
          <b-card-body>
            <b-table :busy="tableBusy" :fields="fields" hover no-border-collapse :items="legEmAndamento?.Documentos"
              sort-by="" :sort-desc="true" striped stacked="lg" show-empty>
              <template #empty>
                <span>Não foram encontrados dados.</span>
              </template>
              <template #emptyfiltered>
                <span>Não foram encontrados dados.</span>
              </template>
              <template #table-busy>
                <div class="text-center text-dark">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong class="loading-text">Carregando...</strong>
                </div>
              </template>
              <template v-slot:cell(NroAno)="row">
                <div>
                  <span>{{ row.item.Numero + "/" + row.item.Ano }}</span>
                </div>
              </template>
              <template v-slot:cell(demais)="row">
                <div>
                  <div v-if="row.item.TipoLegislacao.Sigla === 'AFS' && tipoUg === 'prefeitura'">
                    Valor Fixado Prefeito: {{ formatMoeda(row.item.VlPrefeito) }}
                    <br>
                    Valor Fixado Vice-Prefeito: {{ formatMoeda(row.item.VlVicePrefeito) }}
                  </div>
                  <div v-if="row.item.TipoLegislacao.Sigla === 'AFS' && tipoUg === 'camara'">
                    Valor Fixado Vereador: {{ formatMoeda(row.item.VlVereador) }}
                    <br>
                    Qtd de vereadores: {{ row.item.QtdVereadores }}
                  </div>
                </div>
              </template>
              <template v-slot:cell(actions)="row">
                <div class="actions-icons">
                  <btn-download :fazerDownload="baixarDocumento" :parametros="row.item" />
                  <btn-excluir :idItem="row.item.IdDocumento" :excluirItem="removerDocumento" />
                  <!--span>{{row.item}}</span-->
                </div>
              </template>
            </b-table>
          </b-card-body>
        </b-card>

        <b-card class="m-3" no-body v-if="entregasParaCancelar?.length > 0">
          <template #header>
            <h6 class="mb-0 text-center">
              <span class="titulo-sagres font-weight-bold">
                Entregas que serão canceladas
              </span>
            </h6>
          </template>
          <b-card-body>
            <b-table :busy="tableBusy" :fields="fieldsCancelar" hover no-border-collapse :items="entregasParaCancelar"
              sort-by="" :sort-desc="true" striped stacked="lg" thead-class="bg-danger text-white" show-empty>



              <template #empty>
                <span>Não foram encontrados dados.</span>
              </template>
              <template #emptyfiltered>
                <span>Não foram encontrados dados.</span>
              </template>
              <template #table-busy>
                <div class="text-center text-dark">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong class="loading-text">Carregando...</strong>
                </div>
              </template>
              <template v-slot:cell(Legislacao)="row">
                <div>
                  <span>{{ row.item.Numero + "/" + row.item.Ano + " - " + row.item.TipoAto.Descricao }}</span>
                </div>
              </template>
              <template v-slot:cell(Entrega)="row">
                <div>
                  <span>{{
            row.item.Entrega.Exercicio + " - " + row.item.Entrega.TipoEntrega.Descricao + " (ID: " +
            row.item.Entrega.IdEntrega + ")"
          }}</span>
                </div>
              </template>
              <template v-slot:cell(DataEntrega)="row">
                <div>
                  <span>{{ new Date(row.item.Entrega.DataEntrega).toLocaleDateString() }}</span>
                </div>
              </template>
            </b-table>
          </b-card-body>
        </b-card>

      </b-card-body>
    </b-card>

    <validation-observer ref="validationobserver" v-slot="{ }">
      <b-form @submit.prevent="adicionarDocumento" id="formAddDocumento">
        <b-modal id="documento-modal" size="lg" centered header-bg-variant="secondary" header-text-variant="light"
          header-class="" footer-class="" modal-class="p-2" no-close-on-backdrop no-close-on-esc
          title="Adicionar Documento">

          <b-row class="text-justify mb-3">
            <b-col cols="12">
              <default-form-validation-provider rules="min_value:1" label="Legislação" v-slot="defaultState">
                <b-form-select id="select-filtros-tipo-legislacao" v-model="entregaDocumento.idTipoLegislacao"
                  :options="comboTiposDeLegislacao" :state="defaultState.state"
                  @change="onChangeTipoLegislacao()">
                </b-form-select>
              </default-form-validation-provider>
            </b-col>
          </b-row>
          <b-row class="text-justify mb-3">
            <b-col cols="6">
              <default-form-validation-provider rules="min_value:1" label="Tipo de Ato" v-slot="defaultState">
                <b-form-select id="select-filtros-tipo-ato" v-model="entregaDocumento.idTipoAto"
                  :state="defaultState.state" :options="comboTiposDeAto"
                  :disabled="tipoAtoDesabilitado">
                </b-form-select>
              </default-form-validation-provider>
            </b-col>
            <b-col cols="3">
              <default-form-validation-provider rules="required|min_value:1" label="Número" v-slot="defaultState">
                <b-form-input type="number" id="input-numero" v-model="entregaDocumento.numeroDoc"
                  :state="defaultState.state" />
              </default-form-validation-provider>
            </b-col>
            <b-col cols="3">
              <default-form-validation-provider rules="required|min_value:1800|max_value:2999" label="Ano" v-slot="defaultState">
                <b-form-input type="number" id="input-ano" v-model="entregaDocumento.anoDoc"
                  :state="defaultState.state" />
              </default-form-validation-provider>
            </b-col>
          </b-row>
          <b-row class="text-justify mb-3">
            <b-col cols="6">
              <default-form-validation-provider rules="required" label="Início de Vigência" v-slot="defaultState">
                <b-form-input id="input-vigencia" type="date" v-model="entregaDocumento.inicioVigencia"
                  :state="defaultState.state" />
              </default-form-validation-provider>
            </b-col>
            <b-col cols="6">
              <default-form-validation-provider rules="required" label="Data de Publicação do Ato" v-slot="defaultState">
                <b-form-input id="input-publicacao" type="date" v-model="entregaDocumento.publicacaoAto"
                  :state="defaultState.state" />
              </default-form-validation-provider>
            </b-col>
          </b-row>

          <b-row class="text-justify mb-3" v-if="isPrefeituraFS">
            <b-col cols="6">
              <default-form-validation-provider label="Valor Fixado Prefeito (R$)" v-slot="defState">
                <money class="form-control" v-model="entregaDocumento.vlPrefeito" :state="defState.state"
                  v-bind="vMoneyOptions" />
              </default-form-validation-provider>
            </b-col>
            <b-col cols="6">
              <default-form-validation-provider label="Valor Fixado Vice-Prefeito (R$)" v-slot="defState">
                <money class="form-control" v-model="entregaDocumento.vlVicePrefeito" :state="defState.state"
                  v-bind="vMoneyOptions" />
              </default-form-validation-provider>
            </b-col>
          </b-row>
          <b-row class="text-justify mb-3" v-if="isCamaraFS">
            <b-col cols="6">
              <default-form-validation-provider label="Valor Fixado Vereador (R$)" v-slot="defState">
                <money class="form-control" v-model="entregaDocumento.vlVereador" :state="defState.state"
                  v-bind="vMoneyOptions" />
              </default-form-validation-provider>
            </b-col>
            <b-col cols="6">
              <default-form-validation-provider :rules="isCamaraFS ? 'required' : ''" label="Quantidade de Vereadores" v-slot="defaultState">
                <b-form-input id="input-qtd-vereador" type="number" v-model="entregaDocumento.qtdVereadores"
                  :state="defaultState.state" />
              </default-form-validation-provider>
            </b-col>
          </b-row>

          <b-row class="text-justify mb-3">
            <b-col cols="12">
              <default-form-validation-provider rules="required|ext:pdf" label="Texto da Legislação (PDF)" v-slot="defaultState">
                <b-form-file id="input-novoArquivo" v-model="entregaDocumento.arquivo"
                  :state="defaultState.state" accept=".pdf" placeholder="Escolha um arquivo..."
                  class="mt-3" />
              </default-form-validation-provider>
            </b-col>
          </b-row>


          <template #modal-footer>
            <b-button type="submit" variant="primary" form="formAddDocumento" v-b-modal.modal-prevent-closing>
              Adicionar
            </b-button>
            <b-button variant="outline-secondary" @click="fecharModalDocumento()">
              Cancelar
            </b-button>
          </template>

        </b-modal>
      </b-form>

    </validation-observer>


  </div>
</template>

<script lang="ts">
import { Vue, Component, Ref } from 'vue-property-decorator'
import { store } from "@/store";
import BtnVoltar from '@/components/shared/BtnVoltar.vue'
import BtnDownload from "@/components/shared/btn-download.vue";
import BtnExcluir from '@/components/shared/btn-excluir.vue'
import { ValidationObserver } from "vee-validate";
import legislacaoService from '@/services/entregas/legislacaoService';
import { TableField } from '@/types/table-field';
import { fieldsDocumento } from '@/types/entregas/legislacao/fields-documento';
import { fieldsLegCancelar } from '@/types/entregas/legislacao/fields-leg-cancelar';
import { UtilsTS } from '@/utilsts';
import { SelectValue } from '@/types/select-value';
import { EntregaLegislacaoDto } from '@/types/entregas/legislacao/entrega-legislacao-dto';
import { EntregaDocumentoDto } from '@/types/entregas/legislacao/entrega-documento-dto';
import { mixins } from 'vue-class-component';
import DefaultFormValidationProvider from '@/components/shared/DefaultFormValidationProvider.vue'
import { Money } from 'v-money'

const CompProps = Vue.extend({
  name: 'EntregaLegislacao',
  components: {
    BtnVoltar,
    BtnDownload,
    BtnExcluir,
    DefaultFormValidationProvider,
    Money,
    ValidationObserver,
  },
  props: {
    idEntrega: {
      type: String
    },
    openInModal: {
      type: Boolean
    }
  },
})

@Component
export default class EntregaLegislacao extends mixins(UtilsTS, CompProps) {
  @Ref('validationobserver') validationobserver: InstanceType<typeof ValidationObserver>
  legEmAndamento: any = {}
  entregasParaCancelar: any = {}
  tipoUg = null
  comboExercicio: SelectValue[] = []
  comboTiposDeEntrega: SelectValue[] = []
  tableBusy = false
  fields: TableField[] = fieldsDocumento
  fieldsCancelar: TableField[] = fieldsLegCancelar
  entrega: EntregaLegislacaoDto = new EntregaLegislacaoDto()
  tipoEntregaDesabilitado = true;

  //modal
  entregaDocumento: EntregaDocumentoDto = new EntregaDocumentoDto()
  comboTiposDeLegislacao: SelectValue[] = []
  comboTiposDeAto: SelectValue[] = []
  tipoAtoDesabilitado = true
  tiposLegislacao: any = {}
  isPrefeituraFS = false
  isCamaraFS = false

  isBtnEnviarDesabilitado() {
    return !this.legEmAndamento || this.legEmAndamento?.Documentos?.length === 0
  }

  perguntarRemoverEntrega() {
    this.$bvModal.msgBoxConfirm('Tem certeza que deseja descartar a entrega?', {
      buttonSize: 'sm',
      cancelTitle: 'Cancelar',
      cancelVariant: 'outline-secondary',
      centered: true,
      headerBgVariant: 'secondary',
      headerTextVariant: 'light',
      okTitle: 'Descartar',
      title: 'Confirmar exclusão',
    }).then(value => {
      if (value) this.removerLegislacao()
    }).catch(err => {
      console.error('Erro no modal de limpeza de entrega', err)
    })
  }

  async removerLegislacao(): Promise<void> {
    try {
      store.blockScreen = true
      this.tableBusy = true
      await legislacaoService.excluirLegislacao()
      this.$toast.success('Descartando entrega...');
      await this.inicializarEntrega()
    } catch (e: any) {
      this.tratarError(e)
    } finally {
      store.blockScreen = false
      this.tableBusy = false
      if (this.openInModal) {
        this.$emit('fecharModalLegislacao')
      }
    }
  }

  async removerDocumento(id: number): Promise<void> {
    try {
      store.blockScreen = true
      this.tableBusy = true
      this.legEmAndamento = await legislacaoService.excluirDocumento(id)
      this.$toast.success('Removendo documento...');
      await this.inicializarEntrega()
    } catch (e: any) {
      this.tratarError(e)
    } finally {
      store.blockScreen = false
      this.tableBusy = false
    }
  }

  existeEmAndamento() {
    return this.legEmAndamento !== null;
  }

  habilitarTipoEntrega() {
    this.tipoEntregaDesabilitado = false;
  }

  async adicionarDocumento(): Promise<void> {
    const isValid = await this.validationobserver.validate();
    if (!isValid) {
      return
    }

    try {
      store.blockScreen = true
      this.legEmAndamento = await legislacaoService.salvarDocumento(this.entregaDocumento)
      this.$toast.success('Salvando documento...');
      this.fecharModalDocumento()
      this.inicializarEntrega()
    } catch (e: any) {
      this.tratarError(e)
    } finally {
      store.blockScreen = false
    }

  }

  fecharModalDocumento() {
    this.$bvModal.hide("documento-modal");
  }

  async onChangeTipoLegislacao(): Promise<void> {
    await this.carregarTipoAto()

    const tipoLeg = this.tiposLegislacao.filter(t => t.IdTipoLegislacao === this.entregaDocumento.idTipoLegislacao)[0]

    if (this.legEmAndamento && this.tipoUg === 'prefeitura' && tipoLeg.Sigla === 'AFS') {
      this.isPrefeituraFS = true;
    }
    if (this.legEmAndamento && this.tipoUg === 'camara' && tipoLeg.Sigla === 'AFS') {
      this.isCamaraFS = true;
    }
  }

  async carregarTipoAto(): Promise<void> {
    try {
      store.blockScreen = true
      await this.getComboTiposAto()
      this.tipoAtoDesabilitado = false;
    } finally {
      store.blockScreen = false
    }
  }

  async abrirModalDocumento(): Promise<void> {
    this.tipoAtoDesabilitado = true;
    this.entregaDocumento = new EntregaDocumentoDto()
    this.entregaDocumento.idTipoLegislacao = 0
    this.entregaDocumento.idTipoAto = 0
    this.isPrefeituraFS = false
    this.isCamaraFS = false
    await this.getComboTiposLegislacao()
    this.$bvModal.show("documento-modal")
  }

  async salvarLegislacao() {

    try {
      store.blockScreen = true
      this.legEmAndamento = await legislacaoService.salvarLegislacao(this.entrega)
      this.tipoEntregaDesabilitado = true
      this.$toast.success('Salvando dados da legislação...');
    } catch (e: any) {
      this.tratarError(e)
    } finally {
      store.blockScreen = false
    }
  }

  async enviarLegislacao() {
    try {
      store.blockScreen = true
      await legislacaoService.enviarLegislacao()
      this.$toast.success('Efetuando entrega...');
      if (!this.openInModal) {
        this.$router.push("/entrega/legislacoes")
      }
      else {
        this.$emit('fecharModalLegislacao', true)
      }
    } catch (e: any) {
      this.tratarError(e)
    } finally {
      store.blockScreen = false
    }
  }

  async getComboExercicios() {
    const combos = await legislacaoService.getExercicios()
    this.comboExercicio = [
      { text: 'SELECIONE', value: 0, disabled: true },
      ...combos.map(exercicio => { return { text: String(exercicio), value: exercicio } })
    ]
  }

  async getComboTiposEntrega() {
    const combos = await legislacaoService.getTiposEntrega()
    this.comboTiposDeEntrega = [
      { text: 'SELECIONE', value: 0, disabled: true },
      ...combos.map(tipoEntrega => { return { text: String(tipoEntrega.Descricao), value: tipoEntrega.IdTipoEntrega } })
    ]
  }

  async getComboTiposLegislacao() {
    this.tiposLegislacao = await legislacaoService.getTiposLegislacao()
    this.comboTiposDeLegislacao = [
      { text: 'SELECIONE', value: 0, disabled: true },
      ...this.tiposLegislacao.map(tipoLeg => { return { text: String(tipoLeg.Descricao), value: tipoLeg.IdTipoLegislacao } })
    ]
  }

  async getComboTiposAto() {
    const combos = await legislacaoService.getTiposAto(this.entregaDocumento.idTipoLegislacao)
    this.comboTiposDeAto = [
      { text: 'SELECIONE', value: 0, disabled: true },
      ...combos.map(tipoAto => { return { text: String(tipoAto.Descricao), value: tipoAto.IdTipoAto } })
    ]
  }

  getDescSituacao(situacao) {
    if (situacao == 'E')
      return 'Entregue'
    if (situacao == 'C')
      return 'Cancelada'
    if (situacao == 'M')
      return 'Em Andamento'
    return situacao
  }

  async baixarDocumento(documento) {
    const arq = await legislacaoService.downloadDocumento(documento.IdDocumento)
    this.download(`${documento.Nome ?? 'documento'}.pdf`, arq)
  }

  async inicializarEntrega(): Promise<void> {
    await this.getComboExercicios()
    await this.getComboTiposEntrega()

    const leg = await legislacaoService.getLegislacaoEmAndamento()
    this.legEmAndamento = leg.Legislacao
    this.tipoUg = leg.TipoUg
    this.entregasParaCancelar = leg.LegsCancelar

    if (this.legEmAndamento) {
      this.entrega.idTipoEntrega = this.legEmAndamento.TipoEntrega.IdTipoEntrega
      this.entrega.exercicio = this.legEmAndamento.Exercicio
    } else {
      this.entrega.idTipoEntrega = 0
      this.entrega.exercicio = 0
    }
  }

  async mounted() {
    try {
      this.tableBusy = true
      store.blockScreen = true

      await this.inicializarEntrega()

    } catch (e: any) {
      this.tratarError(e)
      this.$router.push('/entrega/legislacoes');
    } finally {
      store.blockScreen = false
      this.tableBusy = false
    }
  }

}
</script>
